import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PageInfo } from '../vo/page-info.model';

/**
 * 自動コマ配置サービス
 * @export RegistAutoKomaArrangeService
 * @class RegistAutoKomaArrangeService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistAutoKomaArrangeService extends PlessJsonResponderSub<null> {
  model: KYMW4400Model;
  pageList: PageInfo[];
  private calbak: (data: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistAutoKomaArrangeService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        AutoKomaArrange: {
          parameter: {
            OrderCode: this.model.orderCode,
            MediumType: this.model.mediumType,
            CoopCode: this.model.coopCode
          },
          combination: this.pageList.map(_ => ({
            parameter: {
              PageNum: _.pageNum,
            },
          })),
        }
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param pageList
   * @memberof RegistAutoKomaArrangeService
   */
  execute(model: KYMW4400Model, pageList: PageInfo[], f: (data: any) => void = null): void {
    this.model = model;
    this.pageList = pageList;
    this.calbak = f;
    this.send('registAutoKomaArrange', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistAutoKomaArrangeService
   */
  success(data: any) {
    if (this.calbak) this.calbak(data);
  }
}
